module.exports = __webpack_public_path__ + "img/nijl_symbolmark.55727bd1.jpg";